import api from './api';

export default {
  async getUsers() {
    try {
      const response = await api.get('/api/users/', { authRequired: true });
      return response.data;
    } catch (error) {
      return [];
    }
  },
  async createDeposit(user, value) {
    try {

      const payload = {
        "aporte": value,
        "user_option": "existing",
        "users_name": user 
      };

      const response = await api.post('/api/deposit/', payload, { authRequired: true });
      return response.status === 201;
    } catch (error) {
      return false;
    }
  },
  async createUser(user, email, value) {
    try {

      const payload = {
        "aporte": value,
        "user_option": "new",
        "new_user": user,
        "email": email
      };

      const response = await api.post('/api/deposit/', payload, { authRequired: true });
      return response.status === 201;
    } catch (error) {
      return false;
    }
  },
};
